
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.536.628H1.505A1.426 1.426 0 00.013 1.973v10.534a1.426 1.426 0 001.492 1.345h4.729l1.373 1.858a.529.529 0 00.827 0l1.373-1.858h4.729a1.426 1.426 0 001.492-1.345V1.973A1.426 1.426 0 0014.535.628zm.5 11.879a.475.475 0 01-.5.449h-4.99a.514.514 0 00-.414.2l-1.107 1.5-1.107-1.5a.514.514 0 00-.414-.2h-5a.475.475 0 01-.5-.45V1.974a.475.475 0 01.5-.45h13.03a.475.475 0 01.5.45l.002 10.534z","fill":"#919191"}}),_c('path',{attrs:{"d":"M12.887 5.768a.449.449 0 00-.45-.45H2.377a.45.45 0 000 .9h10.062a.449.449 0 00.449-.448v-.002zM2.376 4.125h11.15a.45.45 0 100-.9H2.377a.45.45 0 000 .9zM2.376 8.439h11.29a.45.45 0 00.042-.9H2.373a.45.45 0 000 .9h.003zM10.062 9.767H2.376a.45.45 0 000 .9h7.686a.45.45 0 100-.9z","fill":"#919191"}})])
          )
        }
      }
    